import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IoMdAdd } from 'react-icons/io';

const PhotoUploader = ({ onPhotosChange }) => {
    const [photos, setPhotos] = useState([]);

    const onDrop = (acceptedFiles) => {
        const readFiles = (file) =>
            new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve({ 
                        file, 
                        preview: URL.createObjectURL(file), 
                        base64: reader.result.split(',')[1] 
                    });
                };
                reader.readAsDataURL(file); 
            });

        Promise.all(acceptedFiles.map(readFiles)).then((newPhotos) => {
            if (photos.length + newPhotos.length <= 8) {
                const updatedPhotos = [...photos, ...newPhotos];
                setPhotos(updatedPhotos);
                onPhotosChange(updatedPhotos); 
            } else {
                alert('En fazla 8 fotoğraf yükleyebilirsiniz.');
            }
        });
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/*',
        multiple: true,
    });

    const removePhoto = (index) => {
        const updatedPhotos = [...photos];
        updatedPhotos.splice(index, 1);
        setPhotos(updatedPhotos);
        onPhotosChange(updatedPhotos); 
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                backgroundColor: '#f7f7f7',
                padding: 2,
                borderRadius: '12px',
                border: '1px solid #e0e0e0',
                width: '100%',
                maxWidth: '100%',
            }}
        >
            <Button
                {...getRootProps()}
                variant="outlined"
                startIcon={<IoMdAdd />}
                sx={{
                    color: '#343089',
                    borderColor: '#343089',
                    textTransform: 'none',
                    borderRadius: '24px',
                    '&:hover': { backgroundColor: '#f1f1f1' },
                }}
            >
                <input {...getInputProps()} style={{ display: 'none' }} />
                Fotoğraf Ekle
            </Button>

            <Box
                sx={{
                    display: 'flex',
                    gap: 1,
                    overflowX: 'auto',
                    padding: '4px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                }}
            >
                {photos.map((photo, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: 'relative',
                            width: '40px',
                            height: '40px',
                            borderRadius: '4px',
                            overflow: 'hidden',
                            border: '1px solid #ddd',
                        }}
                    >
                        <img
                            src={photo.preview} 
                            alt={`preview-${index}`}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                        <IconButton
                            onClick={() => removePhoto(index)}
                            sx={{
                                position: 'absolute',
                                top: 2,
                                right: 2,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: '#fff',
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
                                padding: '2px',
                            }}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default PhotoUploader;
